var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "addMixedMode" },
    [
      _c("div", { staticClass: "status_1_content_Indexes" }, [
        _c(
          "ul",
          [
            _vm._l(_vm.questionConfigure, function(item, index) {
              return [
                item.extendOption.isIndexes
                  ? _c(
                      "li",
                      {
                        key: index,
                        attrs: { title: item.extendOption.indexText },
                        on: {
                          click: function($event) {
                            return _vm.handlescroll(item.sort)
                          }
                        }
                      },
                      [
                        _c("span", { staticClass: "el-icon-guide" }),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                item.extendOption.indexText ||
                                  "未命名" + (index + 1)
                              ) +
                              "\n          "
                          )
                        ])
                      ]
                    )
                  : _vm._e()
              ]
            })
          ],
          2
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticStyle: {
            flex: "1",
            display: "flex",
            "flex-direction": "column",
            overflow: "hidden"
          }
        },
        [
          _c(
            "ul",
            { staticClass: "zlItCourseEdit_editor_tools" },
            [
              _vm._l(_vm.option, function(item, index) {
                return _vm.isShow(item)
                  ? _c(
                      "li",
                      {
                        key: index,
                        staticClass: "itemTool",
                        on: {
                          click: function($event) {
                            return _vm.addQuestionItem(item)
                          }
                        }
                      },
                      [
                        _c(
                          "svg",
                          {
                            staticClass: "icon svg-icon",
                            staticStyle: {
                              width: "14px",
                              height: "14px",
                              "vertical-align": "-0.15em"
                            },
                            attrs: { "aria-hidden": "true" }
                          },
                          [_c("use", { attrs: { "xlink:href": item.icon } })]
                        ),
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(item.label))])
                      ]
                    )
                  : _vm._e()
              }),
              _vm._v(" "),
              _c(
                "el-upload",
                {
                  attrs: {
                    action: _vm.importUrl,
                    headers: _vm.headers,
                    accept: "",
                    "show-file-list": false,
                    "on-progress": _vm.handleAvatarProgress,
                    "on-success": _vm.handleAvatarSuccess
                  },
                  model: {
                    value: _vm.addImageText.value,
                    callback: function($$v) {
                      _vm.$set(_vm.addImageText, "value", $$v)
                    },
                    expression: "addImageText.value"
                  }
                },
                [
                  _c("li", { staticClass: "itemTool" }, [
                    _c(
                      "svg",
                      {
                        staticClass: "icon svg-icon",
                        staticStyle: {
                          width: "14px",
                          height: "14px",
                          "vertical-align": "-0.15em"
                        },
                        attrs: { "aria-hidden": "true" }
                      },
                      [
                        _c("use", {
                          attrs: { "xlink:href": "#icon-tianjiafujian1" }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c("span", [_vm._v("附件")])
                  ])
                ]
              )
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "zl_edit_box",
              on: {
                click: function($event) {
                  _vm.textImgVisible = false
                }
              }
            },
            [
              _vm.questionConfigure && _vm.questionConfigure.length
                ? _c(
                    "draggable",
                    {
                      staticClass: "zl_edit_content",
                      attrs: {
                        chosenClass: "chosen",
                        scroll: true,
                        animation: "200",
                        tag: "div",
                        disabled: _vm.isImg
                      },
                      model: {
                        value: _vm.questionConfigure,
                        callback: function($$v) {
                          _vm.questionConfigure = $$v
                        },
                        expression: "questionConfigure"
                      }
                    },
                    [
                      _vm._l(_vm.questionConfigure, function(item, index) {
                        return [
                          item
                            ? _c(
                                "div",
                                {
                                  key: index + item.sort,
                                  ref: "scroll" + item.sort,
                                  refInFor: true,
                                  staticClass: "zl_edit_content_item",
                                  style: item.style,
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.edit_content_focus(
                                        arguments[0],
                                        item,
                                        index
                                      )
                                    },
                                    contextmenu: function($event) {
                                      $event.preventDefault()
                                      return _vm.edit_content_contextmenu(
                                        arguments[0],
                                        item,
                                        index
                                      )
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "zl_edit_collapse_header" },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            display: "inline-block",
                                            width: "65px"
                                          }
                                        },
                                        [
                                          _c(
                                            "svg",
                                            {
                                              staticClass: "icon svg-icon",
                                              staticStyle: {
                                                width: "15px",
                                                height: "15px",
                                                "vertical-align": "-0.08em"
                                              },
                                              attrs: { "aria-hidden": "true" }
                                            },
                                            [
                                              _c("use", {
                                                attrs: {
                                                  "xlink:href":
                                                    _vm.courseIcon[item.type]
                                                      .icon
                                                }
                                              })
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "logospan" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.courseIcon[item.type].alt
                                                )
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      item.type === 1
                                        ? _c("tools", {
                                            class: { showHeight: item.show },
                                            attrs: {
                                              myRef: "editor" + item.sort
                                            },
                                            model: {
                                              value: _vm.activeOne,
                                              callback: function($$v) {
                                                _vm.activeOne = $$v
                                              },
                                              expression: "activeOne"
                                            }
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticStyle: { display: "flex" } },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "zl_edit_collapse_btn",
                                              on: {
                                                click: function($event) {
                                                  return _vm.handleclickitem(
                                                    item
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c("span", {
                                                staticClass:
                                                  "el-icon-arrow-up buxuanzhuan",
                                                class: { xuanzhuan: item.show }
                                              })
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "zl_edit_collapse_btn",
                                              on: {
                                                click: function($event) {
                                                  return _vm.edit_content_contextmenu(
                                                    $event,
                                                    item,
                                                    index,
                                                    "click"
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c("span", {
                                                staticClass: "el-icon-s-tools"
                                              })
                                            ]
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "contentBox",
                                      class: { showHeight: item.show },
                                      style: {
                                        textAlign:
                                          item.styleOption.textDecoration
                                      }
                                    },
                                    [
                                      item.type === 1
                                        ? _c("editor", {
                                            ref: "editor" + item.sort,
                                            refInFor: true,
                                            attrs: {
                                              myRef: "editor" + item.sort,
                                              height: "500px",
                                              jyxStyle: _vm.courseId == 3156
                                            },
                                            model: {
                                              value: item.value,
                                              callback: function($$v) {
                                                _vm.$set(item, "value", $$v)
                                              },
                                              expression: "item.value"
                                            }
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      item.type === 3
                                        ? _c("div", {
                                            staticClass:
                                              "ql-editor editorShowArea",
                                            domProps: {
                                              innerHTML: _vm._s(
                                                item.questionContent
                                              )
                                            }
                                          })
                                        : item.type === 5
                                        ? _c(
                                            "div",
                                            { staticClass: "lianjie" },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.openlianjie(
                                                        item
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v(_vm._s(item.name))]
                                              )
                                            ]
                                          )
                                        : item.type === 7
                                        ? _c("img", {
                                            staticClass: "zl_edit_content_img",
                                            style: {
                                              width: item.styleOption.width
                                                ? item.styleOption.width + "%"
                                                : "50%"
                                            },
                                            attrs: { src: item.value }
                                          })
                                        : item.type === 10
                                        ? _c(
                                            "video",
                                            {
                                              ref: "zl_edit_video" + index,
                                              refInFor: true,
                                              staticClass:
                                                "video-js zl_edit_content_video",
                                              style: {
                                                width:
                                                  item.styleOption.width + "%"
                                              },
                                              attrs: {
                                                controls: "",
                                                controlslist: "nodownload",
                                                preload: "auto",
                                                "data-setup":
                                                  "{'example_option:true}"
                                              }
                                            },
                                            [
                                              item.type == 10
                                                ? _c("source", {
                                                    staticClass: "video",
                                                    attrs: {
                                                      id: "sourceBox",
                                                      src: item.value,
                                                      type: "video/mp4"
                                                    }
                                                  })
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c(
                                                "p",
                                                { staticClass: "vjs-no-js" },
                                                [_vm._v("不支持播放")]
                                              )
                                            ]
                                          )
                                        : item.type === 11
                                        ? _c("code-compiler", {
                                            key: index,
                                            ref: "scroll" + item.sort,
                                            refInFor: true,
                                            attrs: { image_text: "" },
                                            model: {
                                              value: item.value,
                                              callback: function($$v) {
                                                _vm.$set(item, "value", $$v)
                                              },
                                              expression: "item.value"
                                            }
                                          })
                                        : item.type === 12
                                        ? _c(
                                            "div",
                                            { staticClass: "lianjie" },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    item.name || item.value
                                                  )
                                              )
                                            ]
                                          )
                                        : item.type == 110
                                        ? _c("iframe", {
                                            staticStyle: {
                                              width: "100%",
                                              height: "450px"
                                            },
                                            attrs: {
                                              src: _vm.pptIframe + item.value,
                                              frameborder: "0"
                                            }
                                          })
                                        : _vm._e()
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  item.extendOption.isIndexes
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "zl_edit_content_title"
                                        },
                                        [
                                          _c(
                                            "el-tooltip",
                                            {
                                              attrs: {
                                                effect: "dark",
                                                content: item.extendOption.event
                                                  ? "步骤：" +
                                                    item.extendOption
                                                      .indexText +
                                                    "; 事项：" +
                                                    item.extendOption.event
                                                  : "步骤：" +
                                                    item.extendOption.indexText,
                                                placement: "top-start"
                                              }
                                            },
                                            [
                                              _c("span", {
                                                staticClass: "el-icon-guide"
                                              })
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "addMixedMode_right_dialog",
                                      class: {
                                        addMixedMode_right_dialog_show:
                                          _vm.textImgVisible &&
                                          _vm.activeIndex === index
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "create_image_text_popper2_cont"
                                        },
                                        [
                                          _vm.textImgVisible
                                            ? _c(
                                                "svg",
                                                {
                                                  staticClass: "icon svg-icon",
                                                  staticStyle: {
                                                    width: "100px",
                                                    height: "100px"
                                                  },
                                                  attrs: {
                                                    "aria-hidden": "true"
                                                  }
                                                },
                                                [
                                                  _c("use", {
                                                    attrs: {
                                                      "xlink:href":
                                                        _vm.courseIcon[
                                                          _vm.activeOne.type
                                                        ].icon
                                                    }
                                                  })
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.activeOne.extendOption &&
                                          _vm.activeOne.styleOption
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass: "zl_drawer_body"
                                                },
                                                [
                                                  _c(
                                                    "p",
                                                    {
                                                      staticClass: "zl_drawer_p"
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "zl_drawer_label"
                                                        },
                                                        [_vm._v("设置为步骤：")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c("el-switch", {
                                                        attrs: {
                                                          "active-text": "是",
                                                          "inactive-text": "否"
                                                        },
                                                        on: {
                                                          change: function(
                                                            $event
                                                          ) {
                                                            return _vm.isIndexesChange(
                                                              _vm.activeOne
                                                                .extendOption
                                                                .isIndexes
                                                            )
                                                          }
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.activeOne
                                                              .extendOption
                                                              .isIndexes,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.activeOne
                                                                .extendOption,
                                                              "isIndexes",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "activeOne.extendOption.isIndexes"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "p",
                                                    {
                                                      staticClass: "zl_drawer_p"
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "zl_drawer_label"
                                                        },
                                                        [_vm._v("步骤名：")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c("el-input", {
                                                        staticStyle: {
                                                          flex: "1"
                                                        },
                                                        attrs: {
                                                          size: "mini",
                                                          disabled: !_vm
                                                            .activeOne
                                                            .extendOption
                                                            .isIndexes,
                                                          placeholder:
                                                            "请输入索引内容"
                                                        },
                                                        on: {
                                                          blur: function(
                                                            $event
                                                          ) {
                                                            return _vm.indexTextChange(
                                                              _vm.activeOne
                                                                .extendOption
                                                                .indexText
                                                            )
                                                          }
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.activeOne
                                                              .extendOption
                                                              .indexText,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.activeOne
                                                                .extendOption,
                                                              "indexText",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "activeOne.extendOption.indexText"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.activeOne.type === 7 ||
                                                  _vm.activeOne.type === 10
                                                    ? [
                                                        _c(
                                                          "p",
                                                          {
                                                            staticClass:
                                                              "zl_drawer_p"
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "zl_drawer_label"
                                                              },
                                                              [_vm._v("宽度：")]
                                                            ),
                                                            _vm._v(" "),
                                                            _c("el-slider", {
                                                              staticStyle: {
                                                                flex: "1"
                                                              },
                                                              attrs: {
                                                                size: "mini",
                                                                "show-stops": ""
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm.activeOne
                                                                    .styleOption
                                                                    .width,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm
                                                                      .activeOne
                                                                      .styleOption,
                                                                    "width",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "activeOne.styleOption.width"
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "p",
                                                          {
                                                            staticClass:
                                                              "zl_drawer_p"
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "zl_drawer_label"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "对齐方式："
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "el-select",
                                                              {
                                                                staticStyle: {
                                                                  flex: "1"
                                                                },
                                                                attrs: {
                                                                  size: "mini",
                                                                  placeholder:
                                                                    "请选择"
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .activeOne
                                                                      .styleOption
                                                                      .textDecoration,
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm
                                                                        .activeOne
                                                                        .styleOption,
                                                                      "textDecoration",
                                                                      $$v
                                                                    )
                                                                  },
                                                                  expression:
                                                                    "activeOne.styleOption.textDecoration"
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "el-option",
                                                                  {
                                                                    attrs: {
                                                                      label:
                                                                        "左对齐",
                                                                      value:
                                                                        "left"
                                                                    }
                                                                  }
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "el-option",
                                                                  {
                                                                    attrs: {
                                                                      label:
                                                                        "居中对齐",
                                                                      value:
                                                                        "center"
                                                                    }
                                                                  }
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "el-option",
                                                                  {
                                                                    attrs: {
                                                                      label:
                                                                        "右对齐",
                                                                      value:
                                                                        "right"
                                                                    }
                                                                  }
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      ]
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.activeOne.type === 11 &&
                                                  !_vm.isStep
                                                    ? [
                                                        _c(
                                                          "p",
                                                          {
                                                            staticClass:
                                                              "zl_drawer_p"
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "zl_drawer_label"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "展示操作按钮："
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c("el-switch", {
                                                              attrs: {
                                                                "active-text":
                                                                  "是",
                                                                "inactive-text":
                                                                  "否"
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm.activeOne
                                                                    .extendOption
                                                                    .operationIsShow,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm
                                                                      .activeOne
                                                                      .extendOption,
                                                                    "operationIsShow",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "activeOne.extendOption.operationIsShow"
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "p",
                                                          {
                                                            staticClass:
                                                              "zl_drawer_p"
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "zl_drawer_label"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "代码生成文件："
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c("el-switch", {
                                                              attrs: {
                                                                "active-text":
                                                                  "是",
                                                                "inactive-text":
                                                                  "否"
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm.activeOne
                                                                    .extendOption
                                                                    .allCode,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    _vm
                                                                      .activeOne
                                                                      .extendOption,
                                                                    "allCode",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "activeOne.extendOption.allCode"
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        )
                                                      ]
                                                    : _vm._e()
                                                ],
                                                2
                                              )
                                            : _vm._e()
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            : _vm._e()
                        ]
                      }),
                      _vm._v(" "),
                      _c("vue-context-menu", {
                        staticClass: "type6contextmenu",
                        attrs: { contextMenuData: _vm.contextMenuData },
                        on: {
                          deletedata: _vm.deletedata,
                          editerdata: _vm.editerdata,
                          insertOne: _vm.insertOne,
                          setdata: _vm.setdata
                        }
                      })
                    ],
                    2
                  )
                : _c("div", { staticClass: "kong" }, [_vm._v("暂无内容")])
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "el-drawer",
        {
          attrs: {
            visible: _vm.drawer,
            size: "66%",
            "custom-class": "addImageTextDialog",
            "with-header": false,
            "destroy-on-close": "",
            "append-to-body": ""
          },
          on: {
            "update:visible": function($event) {
              _vm.drawer = $event
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "drawerHeader",
              staticStyle: { "font-size": "32px", "font-weight": "600" }
            },
            [
              _vm._v(
                "\n      " + _vm._s("添加" + _vm.addImageText.label) + "\n    "
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { height: "calc(100% - 125px)" } },
            [
              _vm.addImageText.type === 3
                ? _c("add-question", {
                    attrs: {
                      subjectId: _vm.subjectId,
                      courseId: _vm.courseId,
                      course: "",
                      qsType: "3",
                      resourcesFrom: "1"
                    },
                    model: {
                      value: _vm.addImageText.value,
                      callback: function($$v) {
                        _vm.$set(_vm.addImageText, "value", $$v)
                      },
                      expression: "addImageText.value"
                    }
                  })
                : _c("courseResourse", {
                    attrs: {
                      nodeKey: _vm.nodeKey,
                      subjectId: _vm.subjectId,
                      courseId: _vm.courseId,
                      type: _vm.addImageText.type,
                      resourcesFrom: "1"
                    },
                    on: { hhdTeacher: _vm.getRow },
                    model: {
                      value: _vm.addImageText.value,
                      callback: function($$v) {
                        _vm.$set(_vm.addImageText, "value", $$v)
                      },
                      expression: "addImageText.value"
                    }
                  })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "drawerFooter",
              staticStyle: { "text-align": "center" }
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function($event) {
                      _vm.drawer = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.addMixedModeSubmit }
                },
                [_vm._v("确 定\n      ")]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "请选择插入内容",
            visible: _vm.dialogVisible,
            width: "400px",
            "append-to-body": "",
            "custom-class": "tobodydialog"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c(
            "ul",
            [
              _vm._l(_vm.option, function(item, index) {
                return _vm.isShow(item)
                  ? _c(
                      "li",
                      {
                        key: index,
                        staticClass: "itemTool",
                        on: {
                          click: function($event) {
                            return _vm.addQuestionItem(item)
                          }
                        }
                      },
                      [
                        _c(
                          "svg",
                          {
                            staticClass: "icon svg-icon",
                            staticStyle: {
                              width: "14px",
                              height: "14px",
                              "vertical-align": "-0.15em"
                            },
                            attrs: { "aria-hidden": "true" }
                          },
                          [_c("use", { attrs: { "xlink:href": item.icon } })]
                        ),
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(item.label))])
                      ]
                    )
                  : _vm._e()
              }),
              _vm._v(" "),
              _c(
                "el-upload",
                {
                  staticClass: "itemTool",
                  staticStyle: { width: "calc(100% - 40px)" },
                  attrs: {
                    action: _vm.importUrl,
                    headers: _vm.headers,
                    accept: "",
                    "show-file-list": false,
                    "on-progress": _vm.handleAvatarProgress,
                    "on-success": _vm.handleAvatarSuccess
                  },
                  model: {
                    value: _vm.addImageText.value,
                    callback: function($$v) {
                      _vm.$set(_vm.addImageText, "value", $$v)
                    },
                    expression: "addImageText.value"
                  }
                },
                [
                  _c("li", [
                    _c(
                      "svg",
                      {
                        staticClass: "icon svg-icon",
                        staticStyle: {
                          width: "14px",
                          height: "14px",
                          "vertical-align": "-0.15em"
                        },
                        attrs: { "aria-hidden": "true" }
                      },
                      [
                        _c("use", {
                          attrs: { "xlink:href": "#icon-tianjiafujian1" }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c("span", [_vm._v("附件")])
                  ])
                ]
              )
            ],
            2
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9da79614", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9da79614","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/single_resource_course/components/addMixedMode.vue
// module id = null
// module chunks = 